"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CaretUpOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M226.28 608.2C190.5 649.66 219.96 714 274.74 714h474.52c54.78 0 84.24-64.33 48.46-105.8L560.46 333.16c-25.53-29.6-71.39-29.6-96.92 0L226.28 608.2z" } }] }, "name": "caret-up", "theme": "outlined" };
exports.default = CaretUpOutlined;
